import Vue from "vue";
import VueGtag from "vue-gtag";
import Router from "vue-router";
import Inicio from "@/pages/Inicio";
import Validar from "@/pages/Validar";
import DescargarComprobante from "@/pages/DescargarComprobante";
import ValidarResultado from "@/pages/resultados/Validar";
import DescargarResultado from "@/pages/resultados/Descargar";
import DescargarInstructivo from "@/pages/resultados/DescargarInstructivo";

Vue.use(Router);

const router = new Router({
  base: CONTEXT,
  mode: "history",
  routes: [
    {
      path: "*",
      component: Inicio
    },
    {
      path: "/validar",
      name: "Validar",
      component: Validar
    },
    {
      path: "/descargar-comprobante",
      name: "DescargarComprobante",
      component: DescargarComprobante,
      props: true
    },
    {
      path: "/descargar-instructivo",
      name: "DescargarInstructivo",
      component: DescargarInstructivo,
      props: true
    },
    {
      path: "/validar-resultado",
      name: "ValidarResultado",
      component: ValidarResultado
    },
    {
      path: "/descargar-resultado",
      name: "DescargarResultado",
      component: DescargarResultado,
      props: true
    },
    {
      path: "/sae",
      name: "Sae",
      beforeEnter() {
        location.href = PLATAFORMA.SAE;
      }
    },
    {
      path: "/ayuda-oficina-regional",
      name: "AyudaRegional",
      beforeEnter() {
        location.href = PLATAFORMA.AYUDA_OFIC_REGIONAL;
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

Vue.use(
  VueGtag,
  {
    config: {
      id: GTAG_ANALYTICS_KEY
    }
  },
  router
);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js